import { MenuHelper } from '..';
import { useLocale } from './Locale';

export const useMenu = () => {
	let state = useLocale();

	let menuHelper = new MenuHelper();
	return { ...state, menuHelper };
};
